import React from 'react';
import { Body } from '~/components/atom/Typography';
import Dialog from '~/components/organism/ModalsV2/Dialog';
import Overlay from '~/components/organism/ModalsV2/Overlay';
import useKeybinding from '~/hooks/useKeybinding';

const text = {
  delete: {
    title: (name: string) => `Verwijder uitgaande koppeling “${name}”?`,
    body: 'Weet je zeker dat je deze koppeling wilt verwijderen? Dit kan niet ongedaan worden.',
    confirm: 'Verwijderen',
    cancel: 'Afbreken',
  },
  cancel: {
    title: (_name: string) => `Weet je zeker dat je wilt afbreken?`,
    body: 'Weet je zeker dat je al je wijzigingen wilt annuleren? Dit kan niet ongedaan worden.',
    confirm: 'Bevestig',
    cancel: 'Afbreken',
  },
};

export type Props = {
  dataTestId?: string;
  modalShown: 'delete' | 'cancel' | null;
  onClose: () => void;
  headerName: string;
  modalActions: {
    delete: () => void;
    cancel: () => void;
  };
};

const ZapierConfirmModal: React.FCC<Props> = ({
  modalShown,
  onClose,
  headerName,
  modalActions,
}) => {
  useKeybinding({
    keys: 'enter',
    disabled: modalShown == null,
    callback: () => {
      if (!modalShown) return;
      modalActions[modalShown]();
    },
  });

  if (!modalShown) return;

  return (
    <Overlay onClose={onClose}>
      <Dialog
        header={text[modalShown].title(headerName)}
        body={<Body>{text[modalShown].body}</Body>}
        buttons={[
          {
            icon: 'trashcan',
            label: text[modalShown].confirm,
            onClick: modalActions[modalShown],
          },
        ]}
        cancelLabel={text[modalShown].cancel}
      />
    </Overlay>
  );
};

export default ZapierConfirmModal;
